import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
// Core components
import Box from 'components/core/Box';
import Card from 'components/core/Card';
import Typography from 'components/core/Typography';
// Models
import mCarpark from 'models/cpm/carpark';
// Custom
import { cpmCarparkDataShape } from 'constants/PropTypesShapes';
import { DeviceSerialItem } from 'components/items/InformationItems';
import CarparkDeviceStatusItem from './CarparkDeviceStatusItem';
import CarparkDoorItem from './CarparkDoorItem';

const getDeviceDoors = (device, doors) => _filter(mCarpark.sortDoors(doors), ['device.id', device.id]);

const CarparkDevices = ({ carparkData }) => {
  const { devices, doors } = carparkData;

  return (
    <Box type="defaultBackground" className="p-3">
      <div className="row" style={{ marginTop: -16 }}>
        {_map(devices, (device) => (
          <div className="col-12 pt-3" key={device.id}>
            <Card
              title={device.name}
              contentOptions={{
                expandable: true,
                expanded: true,
              }}
            >
              <div className="row information-item-wrapper">
                <div className="col-12 col-md-6">
                  <DeviceSerialItem value={device.serial} />
                </div>
                <div className="col-12 col-md-6">
                  <CarparkDeviceStatusItem device={device} />
                </div>
                <div className="col-12 pt-3">
                  <Typography type="subtitle2">
                    <LocalizedMessage id="subtitle.controlledAccesses" />
                  </Typography>
                  <div className="row">
                    {_map(getDeviceDoors(device, doors), (door) => (
                      <div className="col-12 col-md-8" key={door.id}>
                        <CarparkDoorItem lightMode={false} withEquipments withShadow={false} door={door} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </Box>
  );
};

CarparkDevices.propTypes = {
  carparkData: cpmCarparkDataShape.isRequired,
};

const mapStateToProps = (state) => ({
  carparkData: state.cpmCarpark.current.data,
});

module.exports = connect(
  mapStateToProps,
)(CarparkDevices);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkDevices.js